import styled from 'styled-components';

export const FooterWrapper = styled.footer``;
